import { useContextSelector } from "use-context-selector";
import { SidebarContext } from "../contexts/SidebarContext";

function useSidebar() {
  const toggleSidebar = useContextSelector(SidebarContext, sidebar => sidebar.toggleSidebar);
  const isCollapsed = useContextSelector(SidebarContext, sidebar => sidebar.isCollapsed);
  const isHovered = useContextSelector(SidebarContext, sidebar => sidebar.isHovered);
  const isSearching = useContextSelector(SidebarContext, sidebar => sidebar.isSearching);
  const setIsSearching = useContextSelector(SidebarContext, sidebar => sidebar.setIsSearching);
  const setHover = useContextSelector(SidebarContext, sidebar => sidebar.setHover);

  return {
    toggleSidebar,
    isCollapsed,
    isHovered,
    isSearching,
    setIsSearching,
    setHover,
  };
}

function useMenus() {
  const menus = useContextSelector(SidebarContext, sidebar => sidebar.menus);
  const setActiveMenu = useContextSelector(SidebarContext, sidebar => sidebar.setActiveMenu);

  return {
    menus,
    setActiveMenu,
  };
}

function usePin() {
  const pinMenu = useContextSelector(SidebarContext, sidebar => sidebar.pinMenu);
  const isPinned = useContextSelector(SidebarContext, sidebar => sidebar.isPinned);
  const canPinMenus = useContextSelector(SidebarContext, sidebar => sidebar.canPinMenus);
  const pinnedMenus = useContextSelector(SidebarContext, sidebar => sidebar.pinnedMenus);

  return {
    pinMenu,
    isPinned,
    canPinMenus,
    pinnedMenus
  };
}

export {
  useSidebar,
  useMenus,
  usePin
};
